import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./custom.scss";
import "./custom.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

/** Add Mulish font to the document head */
const link = document.createElement("link");
link.href =
  "https://fonts.googleapis.com/css2?family=Mulish:wght@400;700&display=swap";
link.rel = "stylesheet";
document.head.appendChild(link);

/** Create root element and render the App component */
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);

/** Report web vitals */
reportWebVitals();
